import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/quickPublish',
  title: window.language['menu.quickPublish'],
  component: dynamicWrapper(app,
    [
      import('./model'),
      import('../Program/Playlist/model'),
      import('../System/Org/model'), 
      import('../System/SysConfig/model'),
      import('../Program/Schedule/model'),
      import('../Material/Material/model'),
      import('../HomePage/model'),
    ],
      () => import('./components'))
});

export default app => createRoute(app, routesConfig);


// WEBPACK FOOTER //
// ./src/routes/QuickPublish/index.js